import AdminAddDesignationForm from 'components/form/admin/master/designation/AdminAddDesignationForm'
import AddTestForm from 'components/form/admin/master/test/AddTestForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'


export default class AddTest extends Component {
    render() {
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Add Test</h4>
                                <AddTestForm/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
